export const p1 = require("./p1.jpg")
export const p2 = require("./p2.jpg")
export const p3 = require("./p3.jpg")
export const p4 = require("./p4.jpg")
